import { useGetGroupDetailsQuery } from "generated/graphql"

// Returns the agronomist group
function useAgronomist() {
  const { data } = useGetGroupDetailsQuery({
    variables: {
      groupName: "Agronomist",
    },
  })
  return data?.groupDetails
}
export default useAgronomist
